import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { DeleteSpecialClosingRequest } from '../../resources/establishment/types'
import { useDispatch } from '../redux'
import { AxiosResponse } from 'axios'

export const useDeleteSpecialClosing = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const deleteSpecialClosing = (payload: DeleteSpecialClosingRequest): Promise<AxiosResponse<void>> => {
        setInProgress(true)
        return mutations
            .deleteSpecialClosing(payload)
            .then((response) => {
                setInProgress(false)
                dispatch(actions.deleteSpecialClosing(payload))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        deleteSpecialClosing,
        inProgress,
    }
}
